import { useBaseMediaUrls } from "./useBaseMediaUrls";
import { useRef, useState, useCallback } from "react";

const useVideo = (length = 0) => {
  const [isOnPause, setIsOnPause] = useState(true);
  const [isControls, setIsControls] = useState(false);
  const [currentVideo, setVideo] = useState(0);
  const player = useRef(null);
  const cloudinaryUrl = useBaseMediaUrls("videos");
  const handleOnPause = () => setIsOnPause(true);
  const handleOffPause = () => setIsOnPause(false);
  const handlePlay = () => {
    if (player && player.current) {
      player.current.play();
    }
    setIsControls(true);
  };
  const handleSetCurrentVideo = (id) => setVideo(id);
  const handleNextVideo = useCallback(() => {
    setVideo(currentVideo + 1 === length ? 0 : currentVideo + 1);
  }, [currentVideo, length]);
  const handlePrevVideo = useCallback(() => {
    setVideo(currentVideo === 0 ? length - 1 : currentVideo - 1);
  }, [currentVideo, length]);

  return {
    player,
    isControls,
    handleOffPause,
    handleOnPause,
    handlePlay,
    cloudinaryUrl,
    isOnPause,
    handleSetCurrentVideo,
    handleNextVideo,
    handlePrevVideo,
    currentVideo,
  };
};

export default useVideo;
